import { FEATURE_FLAGS } from "reducer/auth.reducer";

function isFeatureEnabled(flags: string[], feature: keyof typeof FEATURE_FLAGS) {
  const featureTitle = FEATURE_FLAGS[feature]?.title;
  return Boolean(feature && featureTitle && flags?.includes(featureTitle));
}

export default isFeatureEnabled;
